import { useEffect } from 'react'
import { buildGaItem, trackEcommerce } from '../analytics/ga4'

export default function ItemListAnalytics({ products, listId, listName }) {
  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0) return
    const items = products.map((product, index) => buildGaItem(product, 1, undefined, {
      index,
      item_list_id: listId,
      item_list_name: listName,
    }))
    trackEcommerce('view_item_list', items, {
      item_list_id: listId,
      item_list_name: listName,
    })
  }, [products, listId, listName])

  return null
}
